import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, ButtonType } from '@checkmarx/cx-ui';
import PortalTextBox from '../../portal/portalTextBox';
import ValidationTopErrorMessage from '../../portal/controls/validationTopErrorMessage';
import ToastrService from '../../../services/ui/toastrService';
import ToastrLevelsEnum from '../../../services/enums/toastrLevelsEnum';

@inject('translationsStore', 'smtpSettingsStore', 'oidcStore') @observer
export default class TestEmailForm extends Component {

    componentDidMount() {
        
        if(this.props.smtpSettingsStore.lastUsedTestEmailAddress){
            
            this.props.smtpSettingsStore.setTestSmtpEmail(this.props.smtpSettingsStore.lastUsedTestEmailAddress);
        }
        else{
            
            if (this.props.oidcStore.currentUser) {
                let currentUserEmail = this.props.oidcStore.currentUser.profile.email;
                this.props.smtpSettingsStore.setTestSmtpEmail(currentUserEmail);
            }        
        }
    }
    
    fieldWidth = '100%';
    
    handleChangeTestSmtpEmail = e => this.props.smtpSettingsStore.setTestSmtpEmail(e.target.value);
    handleTestSmtpEmailOnBlur = e => this.props.smtpSettingsStore.validateTestSmtpEmail();
    
    sendTestEmail = () => {
        
        const isValid = this.props.smtpSettingsStore.validateTestSmtpEmail();
        
        if (isValid) {

            this.props.smtpSettingsStore.SendTestEmail().then(() => {
                
                this.props.closeModal();
                var level = ToastrLevelsEnum.SUCCESS;
                var message = this.props.translationsStore.translate('SEND_TEST_EMAIL_SUCCESS_MESSAGE');
                ToastrService.triggerToastr({level, message});  
            });
        }
    };
    
    render(){

        return (
            <div>
                <ValidationTopErrorMessage errorMessage={this.props.smtpSettingsStore.sendTestEmailErrorMessage} />
                <PortalTextBox
                    hintText={this.props.translationsStore.translate('RECIPIENT_EMAIL')}
                    floatingLabelText={this.props.translationsStore.translate('RECIPIENT_EMAIL')}
                    onChange={this.handleChangeTestSmtpEmail}
                    onBlur={this.handleTestSmtpEmailOnBlur}
                    errorText={this.props.smtpSettingsStore.testSmtpEmailValidationMessage}
                    disabled={this.props.smtpSettingsStore.sendingTestEmail}
                    value={this.props.smtpSettingsStore.values.testSmtpEmail}
                    width={this.fieldWidth}
                />
                <div className='test-smtp-form-buttons'>
                    <span className='portal-blank-button' onClick={this.props.closeModal}>
                        {this.props.translationsStore.translate('CANCEL')}
                    </span>
                    <Button
                        inProgress={this.props.smtpSettingsStore.sendingTestEmail}
                        onClick={this.sendTestEmail}
                        text={this.props.translationsStore.translate('SEND')} >
                    </Button>
                </div>
            </div>
        );
    }
}